import React from 'react'
import CustomTable from '../../shared/CustomTable'

function PayerLevelTable () {
  return (
    <div>
      <CustomTable
        headers={['Payer ID', 'Payer Name', 'Effective Date', 'End Date']}
        // rows={[{ Name: 'John Doe', Age: 28, Location: 'New York' }]}
      />
    </div>
  )
}

export default PayerLevelTable
